export default [
  {
    id: 1,
    title: { it: "Cabine", en: "Walk-in closets" },
    subTitle: {
      it: "cabina armadio",
      en: "walk-in closet",
    },
    products: [
      {
        sourceImage: require("./images/mainImgs/home/12d.jpg"),
        detailImage: "CabinaHome",
        room: "Home",
        code: "12d",
        name: { it: "Lavanderia", en: "Laundry" },
        size: {
          height: "219,3 - 237,6 - 255,9 - 292,5",
          widths: "42,5 - 47,5 - 57,5 - 87,5 - 97,5 - 117,5",
          depths: "51,8",
        },
      },
      {
        sourceImage: require("./images/mainImgs/home/15a.jpg"),

        detailImage: "CabinaHome",
        room: "Home",
        code: "15a",
        name: { it: "Dispensa", en: "Pantry" },
        size: {
          height: "219,3 - 237,6 - 255,9 - 292,5",
          widths: "42,5 - 47,5 - 57,5 - 87,5 - 97,5 - 117,5",
          depths: "51,8",
        },
      },
      {
        sourceImage: require("./images/mainImgs/home/17c.jpg"),

        detailImage: "CabinaHome",
        room: "Home",
        code: "17c",
        name: { it: "Ripostiglio", en: "Walk-in cupboard" },
        size: {
          height: "219,3 - 237,6 - 255,9 - 292,5",
          widths: "42,5 - 47,5 - 57,5 - 87,5 - 97,5 - 117,5",
          depths: "51,8",
        },
      },
    ],
  },
  {
    id: 2,
    title: { it: "Cabine", en: "Walk-in closets" },
    subTitle: {
      it: "cabina a spalla",
      en: "walk-in closet system with load-bearing side panels",
    },
    products: [
      {
        sourceImage: require("./images/mainImgs/home/11a.jpg"),
        detailImage: "SpallaHome",
        room: "Home",
        code: "03b",
        name: { it: "Camera", en: "Bedroom" },
        size: {
          height: "221,3 - 239,6 - 257,9 - 294,5",
          widths: "48 - 63 - 93 - 123",
          depths: "43 - 44,5",
        },
      },
      {
        sourceImage: require("./images/mainImgs/home/15b.jpg"),
        detailImage: "SpallaHome",
        room: "Home",
        code: "15b",
        name: { it: "Dispensa", en: "Pantry" },
        size: {
          height: "221,3 - 239,6 - 257,9 - 294,5",
          widths: "48 - 63 - 93 - 123",
          depths: "43 - 44,5",
        },
      },
      {
        sourceImage: require("./images/mainImgs/public/13b.jpg"),

        detailImage: "SpallaPublic",
        room: "Public",
        code: "13b",
        name: { it: "Aparthotel", en: "Serviced apartament" },
        size: {
          height: "221,3 - 239,6 - 257,9 - 294,5",
          widths: "48 - 63 - 93 - 123",
          depths: "43 - 44,5",
        },
      },
      {
        sourceImage: require("./images/mainImgs/public/15a.jpg"),

        detailImage: "SpallaPublic",
        room: "Public",
        code: "15a",
        name: { it: "Negozio", en: "Store" },
        size: {
          height: "221,3 - 239,6 - 257,9 - 294,5",
          widths: "48 - 63 - 93 - 123",
          depths: "43 - 44,5",
        },
      },
    ],
  },
  {
    id: 3,
    title: { it: "Cabine", en: "Walk-in closets" },
    subTitle: { it: "cabina cremagliera", en: "slotted rail walk-in closet" },
    products: [
      {
        sourceImage: require("./images/mainImgs/home/08e.jpg"),
        detailImage: "CremaHome",
        room: "Home",
        code: "08e",
        name: { it: "Camera", en: "Bedroom" },
        size: {
          height: "221,3 - 239,6 - 257,9",
          widths: "45 - 60 - 90 - 120",
          depths: "40,8 - 50,8",
        },
      },
      {
        sourceImage: require("./images/mainImgs/home/09b.jpg"),
        detailImage: "CremaHome",
        room: "Home",
        code: "09b",
        name: { it: "Camera", en: "Bedroom" },
        size: {
          height: "221,3 - 239,6 - 257,9",
          widths: "45 - 60 - 90 - 120",
          depths: "40,8 - 50,8",
        },
      },
      {
        sourceImage: require("./images/mainImgs/home/14a.jpg"),
        detailImage: "CremaHome",
        room: "Home",
        code: "14a",
        name: { it: "Lavanderia", en: "Laundry" },
        size: {
          height: "221,3 - 239,6 - 257,9",
          widths: "45 - 60 - 90 - 120",
          depths: "40,8 - 50,8",
        },
      },
      {
        sourceImage: require("./images/mainImgs/home/17a.jpg"),
        detailImage: "CremaHome",
        room: "Home",
        code: "17a",
        name: { it: "Ripostiglio", en: "Walk-in cupboard" },
        size: {
          height: "221,3 - 239,6 - 257,9",
          widths: "45 - 60 - 90 - 120",
          depths: "40,8 - 50,8",
        },
      },
      {
        sourceImage: require("./images/mainImgs/public/10a.jpg"),
        detailImage: "CremaPublic",
        room: "Public",
        code: "10a",
        name: { it: "Camera hotel", en: "Hotel room" },
        size: {
          height: "221,3 - 239,6 - 257,9",
          widths: "45 - 60 - 90 - 120",
          depths: "40,8 - 50,8",
        },
      },
      {
        sourceImage: require("./images/mainImgs/public/11b.jpg"),
        detailImage: "CremaPublic",
        room: "Public",
        code: "11b",
        name: { it: "Camera hotel", en: "Hotel room" },
        size: {
          height: "221,3 - 239,6 - 257,9",
          widths: "45 - 60 - 90 - 120",
          depths: "40,8 - 50,8",
        },
      },
      {
        sourceImage: require("./images/mainImgs/public/11c.jpg"),
        detailImage: "CremaPublic",
        room: "Public",
        code: "11c",
        name: { it: "Camera hotel", en: "Hotel room" },
        size: {
          height: "221,3 - 239,6 - 257,9",
          widths: "45 - 60 - 90 - 120",
          depths: "40,8 - 50,8",
        },
      },
      {
        sourceImage: require("./images/mainImgs/public/16b.jpg"),
        detailImage: "CremaPublic",
        room: "Public",
        code: "16b",
        name: { it: "Negozio", en: "Store" },
        size: {
          height: "221,3 - 239,6 - 257,9",
          widths: "45 - 60 - 90 - 120",
          depths: "40,8 - 50,8",
        },
      },
    ],
  },
];
